import { createSlice } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

// Page-local UI state for the RuleEditor page. Server data (rule + history)
// lives in TanStack Query; this slice holds only pure UI bits: which modal is
// open, test-results table pagination, and the "Test" trigger counter.

export const RULE_EDITOR_REDUCER_NAME = "rule-editor";

const initialState = {
  detailsPopupOpen: false,
  testTablePage: 0,
  testTableTake: 20,
  // Increments on each Test click. Consumers gate the results fetch on a
  // non-zero count so the table stays empty until the user explicitly runs it.
  testRunNonce: 0,
};

const ruleEditorSlice = createSlice({
  name: RULE_EDITOR_REDUCER_NAME,
  initialState,
  reducers: {
    openDetailsPopup: (state) => {
      state.detailsPopupOpen = true;
    },
    closeDetailsPopup: (state) => {
      state.detailsPopupOpen = false;
    },
    setTestTablePage: (state, { payload }) => {
      state.testTablePage = payload;
    },
    setTestTableTake: (state, { payload }) => {
      state.testTableTake = payload;
      state.testTablePage = 0;
    },
    triggerTestRun: (state) => {
      state.testRunNonce += 1;
      state.testTablePage = 0;
    },
    clearRuleEditor: () => ({ ...initialState }),
  },
});

export const {
  openDetailsPopup,
  closeDetailsPopup,
  setTestTablePage,
  setTestTableTake,
  triggerTestRun,
  clearRuleEditor,
} = ruleEditorSlice.actions;

export default ruleEditorSlice.reducer;

export const useSelectDetailsPopupOpen = () =>
  useSelector((s) => s[RULE_EDITOR_REDUCER_NAME].detailsPopupOpen);

export const useSelectTestTablePage = () =>
  useSelector((s) => s[RULE_EDITOR_REDUCER_NAME].testTablePage);

export const useSelectTestTableTake = () =>
  useSelector((s) => s[RULE_EDITOR_REDUCER_NAME].testTableTake);

export const useSelectTestRunNonce = () =>
  useSelector((s) => s[RULE_EDITOR_REDUCER_NAME].testRunNonce);
